import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "../../assets/image";
import { ButtonTag } from "../../commons/MicroComponents";

const SingpassError = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get error details from URL parameters
  const error = searchParams.get("error");
  const errorDescription = searchParams.get("error_description");
  const errorCode = searchParams.get("error_code");

  // Get stored email and id for retry
  const email = sessionStorage.getItem("email");
  const id = sessionStorage.getItem("id");

  const getErrorMessage = () => {
    if (error === "access_denied") {
      return "You have denied access to your Singpass information. Please try again and grant the necessary permissions.";
    } else if (error === "invalid_request") {
      return "There was an issue with the authentication request. Please try again.";
    } else if (error === "server_error") {
      return "Singpass service is temporarily unavailable. Please try again later.";
    } else if (error === "temporarily_unavailable") {
      return "Singpass service is temporarily unavailable. Please try again in a few minutes.";
    } else if (errorDescription) {
      return errorDescription;
    } else {
      return "We were unable to retrieve your information from Singpass. This could be due to network issues or service unavailability.";
    }
  };

  const handleRetry = () => {
    // Clear any stored error state
    sessionStorage.removeItem("singpass_error");

    // Navigate back to Singpass page with stored email and id
    if (email && id) {
      navigate(`/singpass/${id}/${email}`);
    } else {
      navigate("/sign-up");
    }
  };

  const handleManualSignup = () => {
    // Clear Singpass-related session storage
    sessionStorage.removeItem("singpass_code_verifier");
    sessionStorage.removeItem("singpass_error");

    navigate("/sign-up", {
      state: { fromSingpass: true },
    });
  };

  return (
    <div>
      <div className="main">
        <div className="main-logo">
          <img src={Logo} alt="logo" className="w-full h-full object-cover" />
        </div>
        <div className="center-h">
          <section className="w-full">
            <div className="max-w-2xl w-full mx-auto space-y-7">
              {/* Error Icon */}
              <div className="flex justify-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
                  <svg
                    className="w-10 h-10 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z"
                    />
                  </svg>
                </div>
              </div>

              {/* Error Content */}
              <div className="text-center font-ebGaramond space-y-4">
                <h1 className="text-3xl text-red-600">Authentication Failed</h1>
                <p className="text-xl text-gray-700">{getErrorMessage()}</p>

                {/* Show error code if available */}
                {errorCode && (
                  <p className="text-sm text-gray-500">
                    Error Code: {errorCode}
                  </p>
                )}
              </div>

              {/* Action Buttons */}
              <div className="space-y-4">
                <div className="flex justify-center">
                  <ButtonTag
                    onClick={handleRetry}
                    className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold"
                    value="Try Singpass Again"
                  />
                </div>

                <div className="flex justify-center">
                  <ButtonTag
                    onClick={handleManualSignup}
                    className="bg-gray-600 hover:bg-gray-700 text-white px-8 py-3 rounded-lg font-semibold"
                    value="Continue with Manual Registration"
                  />
                </div>
              </div>

              {/* Help Text */}
              <div className="text-center text-sm text-gray-500">
                <p>
                  If you continue to experience issues, please contact our
                  support team or proceed with manual registration.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SingpassError;
